export const handleKeyDown = (event: any, callback?: () => void) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    callback ? callback() : (event.target as HTMLElement).click();
  }
};
